import { call, put, select } from 'redux-saga/effects';
import { fetchAddUrlFailure, fetchAddUrlSuccess } from '../actions';
import { FetchAddUrlResponse, getAddOrganisationUrl } from '../api';
import { FetchAddUrlRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { navigateToExternalPage } from 'utils/validation/common';
import { checkResponse } from 'store/utils';
import { getAuthUser } from 'store/auth/selectors';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchAddUrlSaga(action: FetchAddUrlRequestAction) {
  try {
    let err: ApiError | null;

    const { providerName, uuid, sourceUrl, providerFormattedName } = action.payload;
    const response: FetchAddUrlResponse = yield call(
      getAddOrganisationUrl,
      providerName,
      uuid,
      sourceUrl
    );
    const orgUrl: string = response.data.url;

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('login.page-title-contacting', {
        provider: providerFormattedName,
      }),
      description: i18n.t('login.please-be-patient-it-might-take-few-seconds'),
      type: MessageStates.INFO,
    };
    yield put(turnMessageOn(message));
    yield call(navigateToExternalPage, orgUrl);
    yield put(fetchAddUrlSuccess());
    const currentUser = yield select(getAuthUser);
    if (currentUser) {
      localStorage.removeItem(`vies-infos-${currentUser.userUuid}`);
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchAddUrlFailure());
  }
}
